var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"hint-img",attrs:{"src":_vm.isCollapsing ? '../../../../static/actions/collapse.svg' : '../../../../static/actions/expand.svg',"alt":"Icon to demonstrate grouping action"},on:{"click":function($event){return _vm.$emit('click')}}})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ec156af","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/utils/buttons/GroupingIcon.vue
// module id = null
// module chunks = 